import React from "react";
import PT from "prop-types";
import PlusIcon from "_c/icon/Plus";
import { CircleButton } from "_c/button";

const LoadPhotoButton = ({ toggleForm, type, t }) => (
  <CircleButton
    css={`
      margin-top: 10px;
    `}
    centered
    greenish
    large
    onClick={toggleForm}
    title={
      type === "master"
        ? t("common:portfolio.master_load_tip")
        : t("common:portfolio.client_load_tip")
    }
    aria-label="добавить фото"
  >
    <PlusIcon color="white" />
  </CircleButton>
);
LoadPhotoButton.propTypes = {
  type: PT.oneOf(["master", "client", "saloon"]),
  isOpen: PT.bool,

  t: PT.func.isRequired,
  toggleForm: PT.func.isRequired,
};
export default LoadPhotoButton;
